export default __webpack_public_path__ + "4d640ad5aa95d1360f7c8c38e9c8b0d8.wasm";